import { Injectable } from '@angular/core';

import { SlideDurationValues } from '../../shared/constants/slide-duration-values';
import { SlideDuration as DurationBand } from '../../shared/enums';
import { SignageConfigurationModel } from '../config/models';
import { SlideTiming } from './models';
import { SlideTimingKind } from './enums';

const MAX_WORDS = 30;

@Injectable({ providedIn: 'root' })
export class SlideDurationPolicyService {
  public timingFor(text: string, config: SignageConfigurationModel): SlideTiming {
    const band = SlideDurationValues[config.raw.slideDuration] || SlideDurationValues[DurationBand.Medium];
    const words = text.trim() ? text.trim().split(/\s+/).length : 0;

    return { kind: SlideTimingKind.Timed, milliseconds: Math.min(band.maxDuration, Math.max(band.minDuration, words)) * 1000 };
  }

  public shorten(text: string = ''): string {
    const words = text.split(' ');

    return words.length > MAX_WORDS ? `${words.slice(0, MAX_WORDS).join(' ')}...` : text;
  }
}
